import OrderHistoryMain from "../../component/Member/components/OrderHistory/OrderHistoryMain";
import NavBar from "../../component/NavBar/NavBar";

function OrderHistory() {
    return (
        <>
            <NavBar />
            <OrderHistoryMain />

        </>
    );
}

export default OrderHistory;